@if (puffs() && puffs().length > 0) {
  @for (item of puffs(); let i = $index; track item.id) {
    <app-guide-puff
      [forceContentCssClass]="'px-0 py-6'"
      [index]="i"
      [puffData]="item"
      [numberOfPriorityPuffs]="numberOfPriorityPuffs()"
      class="w-full md:w-[49%]"
    ></app-guide-puff>
  }
}
